module.exports = __webpack_public_path__ + "static/media/lastActive.85604243.svg";